// 2026-10-07 トップの写真のスライドショーと、設置事例・動画・関連商品の横に流す一覧（トップ・商品ページで共通）
(() => {
  // 商品ページでは「動画・設置事例」と「関連商品」の 2 つの区画がこのファイルを読むため、2 回目は何もしない
  if (window.jdCarouselStarted) return;
  window.jdCarouselStarted = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // 対応の無い商品ページの動画・設置事例と、関連商品の「ほかの分類の商品」：候補から、表示のたびに無作為で n 件だけ見せる（Liquid の結果はキャッシュされるため、ここで選ぶ）
  document.querySelectorAll('[data-jd-random]').forEach((track) => {
    const count = Number(track.dataset.jdRandom) || 4;
    // 「もっと見る」のカード（data-jd-keep-last）は選ぶ対象にせず、いつも最後に置く
    const items = Array.from(track.children).filter((item) => !item.hasAttribute('data-jd-keep-last'));
    const last = track.querySelector('[data-jd-keep-last]');
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    items.forEach((item, index) => {
      item.hidden = index >= count;
      track.appendChild(item);
    });
    if (last) track.appendChild(last);
    // 並べ替えると、ブラウザが元の 1 枚目に吸着し直して一覧が途中から始まることがあるため、先頭に戻す
    track.scrollLeft = 0;
    requestAnimationFrame(() => { track.scrollLeft = 0; });
  });

  // 横に流す一覧：前へ・次へのボタン（自動では動かない）
  document.querySelectorAll('[data-jd-cases]').forEach((root) => {
    const track = root.querySelector('[data-jd-cases-track]');
    const prev = root.querySelector('[data-jd-cases-prev]');
    const next = root.querySelector('[data-jd-cases-next]');
    if (!track || !prev || !next) return;
    const nav = prev.parentElement;
    const step = () => {
      const card = Array.from(track.children).find((item) => !item.hidden);
      return (card ? card.getBoundingClientRect().width : track.clientWidth) + 16;
    };
    const update = () => {
      const fits = track.scrollWidth <= track.clientWidth + 4;
      nav.hidden = fits;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    const behavior = () => (reduceMotion.matches ? 'auto' : 'smooth');
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: behavior() }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: behavior() }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // トップの最初の区画：設置事例の写真のスライドショー
  document.querySelectorAll('[data-jd-slides]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-jd-slide]'));
    const prev = root.querySelector('[data-jd-slides-prev]');
    const next = root.querySelector('[data-jd-slides-next]');
    const counter = root.querySelector('[data-jd-slides-count]');
    if (slides.length < 2 || !prev || !next || !counter) return;

    const INTERVAL = 4000; // 2026-10-08 6 秒 → 4 秒
    let index = 0;
    let timer = null;
    // 自動で切り替えないとき：動きを減らす設定のとき、前へ・次へ・← → で自分で動かした後（止めるボタンは 2026-10-08 に外した）
    let autoOff = reduceMotion.matches;
    let hovering = false;
    let focused = false;
    let onScreen = true;

    // 2 枚目以降は、表示する直前に読み込む（最初の表示を軽くする）
    const load = (i) => {
      const img = slides[i].querySelector('img[data-src]');
      if (!img) return Promise.resolve();
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      return img.decode ? img.decode().catch(() => {}) : Promise.resolve();
    };
    const ready = (i) => {
      const img = slides[i].querySelector('img');
      if (!img || img.dataset.src) return load(i);
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => { img.addEventListener('load', resolve, { once: true }); img.addEventListener('error', resolve, { once: true }); });
    };

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      load(index);
      slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
      counter.textContent = `${index + 1} / ${slides.length}`;
    };

    const playing = () => !autoOff && !hovering && !focused && onScreen && !document.hidden;

    const schedule = () => {
      clearTimeout(timer);
      timer = null;
      if (!playing()) return;
      const upcoming = (index + 1) % slides.length;
      load(upcoming);
      timer = setTimeout(() => {
        ready(upcoming).then(() => { if (playing()) { show(upcoming); schedule(); } });
      }, INTERVAL);
    };

    // 自動で切り替える間は、何枚目かを読み上げない（4 秒ごとに読み上げると邪魔になるため）
    const render = () => { counter.setAttribute('aria-live', autoOff ? 'polite' : 'off'); };
    // 自分で動かしたら、その後は自動では切り替えない（タッチの画面にはマウスを載せて止める方法が無いため）
    const go = (i) => { autoOff = true; render(); show(i); schedule(); };

    prev.addEventListener('click', () => go(index - 1));
    next.addEventListener('click', () => go(index + 1));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
    });
    root.addEventListener('mouseenter', () => { hovering = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    reduceMotion.addEventListener?.('change', (event) => { if (event.matches) { autoOff = true; render(); schedule(); } });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => { onScreen = entries[0].isIntersecting; schedule(); }, { threshold: 0.2 }).observe(root);
    }

    root.classList.add('is-ready');
    render();
    // 1 枚目を出し終えてから、次の写真の読み込みと切り替えを始める
    const start = () => schedule();
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  });
})();
